export default "__VITE_ASSET__BcT0fGb$__"